import { graphql } from '@/generated/gql';

export const DEMAND_REQUEST_MUTATION = graphql(/* GraphQL */ `
  mutation DemandRequestUpdate($demandId: UUID!, $demandRequest: TsrctDemandRequestInput!) {
    tesseract {
      demand(id: $demandId) {
        demandRequest {
          update(data: $demandRequest) {
            id
            lineItems {
              id
              position
              title
              description
              unitId
              quantity
              shipmentTerms {
                earlyDeliveryAt
                lateDeliveryAt
              }
              updatedAt
              preferredSupplierId
              internalId
              expectedPricePerUnit
              commodityGroupId
              contractItemId
              analysisId
              organizationId
              deliveryLocationId
              commodityId
              baselinePricePerUnit
            }
          }
        }
      }
    }
  }
`);
